export default __webpack_public_path__ + "static/media/AOU - Overaly .a675357b.mov";